import React from "react";

const RejectModal = ({ open, filename, notes, setNotes, onClose, onConfirm, loading }) => {
  if (!open) return null;
  return (
    <div className="fixed inset-0 bg-black/30 flex items-center justify-center z-50">
      <div className="w-full max-w-md bg-white rounded-xl shadow p-4">
        <h3 className="text-lg font-semibold mb-2">반려 사유 입력</h3>
        <p className="text-sm text-gray-500 mb-3">
          파일: <b className="break-all">{filename}</b>
        </p>
        <textarea
          value={notes}
          onChange={(e) => setNotes(e.target.value)}
          rows={5}
          className="w-full border rounded-lg p-2 text-sm"
          placeholder="반려 사유를 입력하세요."
        />
        <div className="mt-3 flex justify-end gap-2">
          <button onClick={onClose} className="px-3 py-1.5 rounded border" disabled={loading}>취소</button>
          <button onClick={onConfirm} className="px-3 py-1.5 rounded bg-red-600 text-white disabled:opacity-50" disabled={loading}>
            반려 저장
          </button>
        </div>
      </div>
    </div>
  );
};

export default RejectModal;
